import React from "react";
import { Link } from "react-router-dom";
import TestimonialCard from "../cards/TestimonialCard";
import "./TestimonialsSection.css";
import { websitePaths } from "../../../routes/websitePaths";
import { useFetchApprovedReviewsQuery } from "../../../store/api/reviewsApi";

const STATIC_FALLBACK = [
  {
    id: "s1",
    name: "Col. Sohan Singh",
    city: "Lucknow",
    projectType: "Residential Construction",
    year: 2022,
    rating: 5,
    quote: "The team delivered exactly what was planned, on time and with great attention to detail.",
  },
  {
    id: "s2",
    name: "Pradeep Kumar",
    city: "Barabanki",
    projectType: "Commercial Project",
    year: 2022,
    rating: 5,
    quote: "Professional coordination from start to finish. The site supervision and quality checks were thorough.",
  },
  {
    id: "s3",
    name: "Akhand Pratap Singh",
    city: "Lucknow",
    projectType: "Renovation",
    year: 2021,
    rating: 5,
    quote: "They helped us choose the right construction approach and stayed transparent throughout the process.",
  },
];

const TestimonialsSection: React.FC = () => {
  const { data: approved = [], isLoading } = useFetchApprovedReviewsQuery();

  const displayItems = approved.length > 0
    ? approved.slice(0, 3).map((r) => ({
        id: String(r.id),
        name: r.customerName,
        city: r.city,
        projectType: r.projectTitle || "Construction",
        year: r.createdAt ? new Date(r.createdAt).getFullYear() : new Date().getFullYear(),
        rating: r.rating,
        quote: r.comment,
      }))
    : STATIC_FALLBACK;

  return (
    <section className="container my-5 portfolio-section">
      <h3 className="text-center website-section-title">What Our Customers Say</h3>
      <p className="text-center website-section-subtitle mb-4">
        Real feedback from clients who trusted us for construction, renovation, and site support work.
      </p>

      {isLoading ? (
        <div className="text-center py-4 text-muted">Loading reviews…</div>
      ) : (
        <div className="row g-4">
          {displayItems.map((t) => (
            <TestimonialCard key={t.id} {...t} />
          ))}
        </div>
      )}

      <div className="text-center mt-4">
        <Link to={websitePaths.reviews.videos} className="btn brand-btn-primary btn-sm px-3">
          View More Reviews
        </Link>
      </div>
    </section>
  );
};

export default TestimonialsSection;
